(function () {
  const modal = document.querySelector('[data-glb-modal]');

  const btn   = document.querySelector('[data-glb-modal-open]');

  if (!modal || !btn) return;



  const closeEls = modal.querySelectorAll('[data-glb-modal-close]');



  function openModal() {

    modal.hidden = false;

    document.documentElement.classList.add('glb-modal-open');

  }



  function closeModal() {

    modal.hidden = true;

    document.documentElement.classList.remove('glb-modal-open');

  }



  btn.addEventListener('click', openModal);



  closeEls.forEach(el => {

    el.addEventListener('click', closeModal);

  });



  modal.addEventListener('click', e => {

    if (e.target === modal) closeModal();

  });



  document.addEventListener('keydown', e => {

    if (e.key === 'Escape') closeModal();

  });

})();

